import React, { Component } from "react";
import "./Dropdown.css";
import axios from "axios";
import ConfirmationModal from "./ConfirmationModal"; // Import the confirmation modal component

export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndustry: "faq",
      apiResponse: "",
      showConfirmationModal: false,
      newSelectedIndustry: "",
    };
  }

  // handleRadioChange = (event) => {
  //   const selectedIndustry = event.target.value;
  //   this.setState({ selectedIndustry }); // Update the state with the selected radio button
  //   this.props.onIndustryChange(selectedIndustry);
  // };

  // handleRadioChange = (event) => {
  //   const pendingIndustry = event.target.value;
  //   this.setState({ showConfirmationModal: true, pendingIndustry });
  // };

  // handleConfirmChange = () => {
  //   this.setState(
  //     (prevState) => ({
  //       selectedIndustry: prevState.pendingIndustry,
  //       showConfirmationModal: false,
  //       pendingIndustry: null,
  //     }),
  //     () => {
  //       this.props.onIndustryChange(this.state.selectedIndustry);
  //     }
  //   );
  // };

  handleRadioChange = (event) => {
    if (this.props.isApiInProgress) {
      alert("Please wait for the current response before changing the option.");
      return;
    }
    const selectedIndustry = event.target.value;
    if (this.props.hasUserInput) {
      this.setState({
        showConfirmationModal: true,
        newSelectedIndustry: selectedIndustry,
      });
    } else {
      this.setState({ selectedIndustry: selectedIndustry });
      this.props.onIndustryChange(selectedIndustry);
    }
  };

  handleConfirmChange = () => {
    this.setState({
      showConfirmationModal: false,
      selectedIndustry: this.state.newSelectedIndustry,
    });
    this.props.onIndustryChange(this.state.newSelectedIndustry);
  };

  handleCloseModal = () => {
    this.setState({ showConfirmationModal: false });
  };

  render() {
    return (
      <div style={{ textAlign: "left" }}>
        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Search via...
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="mt-3">
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="All"
                      id="checkboxall"
                      name="industry"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "All"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkboxall"
                    >
                      <strong className="color1">ALL-</strong>Across the
                      internet
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="faq"
                      id="checkboxfaq"
                      name="industry"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "faq"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkboxfaq"
                    >
                      <strong className="color1">FAQ-</strong>Accenture Specific
                    </label>
                  </div>
                </div>
                {/* <strong className="color1">ALL-</strong>Across the internet
                <br />
                <strong className="color1">FAQ-</strong>Accenture Specific */}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Industry
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="mt-3">
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="Retail"
                      id="checkbox1"
                      name="industry"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "Retail"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox1"
                    >
                      Retail
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="Utilities"
                      id="checkbox2"
                      name="industry"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "Utilities"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox2"
                    >
                      Utilities
                    </label>
                  </div>
                  {/* <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value=""
                      id="checkbox3"
                      name="industry"
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox3"
                    >
                      Chemicals
                    </label>
                  </div> */}
                  {/* <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value=""
                      id="checkbox4"
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox4"
                    >
                      Health
                    </label>
                  </div> */}
                  {/* <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value=""
                      id="checkbox5"
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox5"
                    >
                      Life Sciences
                    </label>
                  </div> */}
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="consumer"
                      id="checkbox6"
                      name="industry"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "consumer"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox6"
                    >
                      Consumer goods and services
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Theme
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {/* <div className="tt">SUSTAINABILITY GROWTH THEME</div> */}
                <div className="mt-3">
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="measurement"
                      id="checkbox7"
                      name="theme"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "measurement"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox7"
                    >
                      Sust. Measurement
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="technology"
                      id="checkbox8"
                      name="theme"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "technology"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox8"
                    >
                      Sust. Technology
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="sustData"
                      id="checkbox9"
                      name="theme"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "sustData"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox9"
                    >
                      Sust. Data
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="valueChain"
                      id="checkbox10"
                      name="theme"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "valueChain"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox10"
                    >
                      Sust. value chain
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      value="activecenter"
                      id="checkbox11"
                      name="theme"
                      onChange={this.handleRadioChange}
                      checked={this.state.selectedIndustry === "activecenter"} // Bind checked state
                    />
                    <label
                      className="form-check-label custom-label"
                      htmlFor="checkbox11"
                    >
                      Sust. Accessibility Activation Center
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                Learning
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {/* <div className="tt">LEARNING</div> */}
                <div className="accordion mt-3" id="nestedAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="nestedHeadingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#nestedCollapseOne"
                        aria-expanded="true"
                        aria-controls="nestedCollapseOne"
                      >
                        Courses
                      </button>
                    </h2>
                    <div
                      id="nestedCollapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="nestedHeadingOne"
                      data-bs-parent="#nestedAccordion"
                    >
                      {/* <div className="accordion-body">
                        <div className="tt">Courses</div>
                      </div> */}
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="nestedHeadingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#nestedCollapseTwo"
                        aria-expanded="false"
                        aria-controls="nestedCollapseTwo"
                      >
                        Exercises
                      </button>
                    </h2>
                    <div
                      id="nestedCollapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="nestedHeadingTwo"
                      data-bs-parent="#nestedAccordion"
                    >
                      {/* <div className="accordion-body">
                        <div className="tt">EXERCISES</div>
                      </div> */}
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="nestedHeadingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#nestedCollapseThree"
                        aria-expanded="false"
                        aria-controls="nestedCollapseThree"
                      >
                        Assessments
                      </button>
                    </h2>
                    <div
                      id="nestedCollapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="nestedHeadingThree"
                      data-bs-parent="#nestedAccordion"
                    >
                      {/* <div className="accordion-body">
                        <div className="tt">ASSESSMENTS</div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item mb-3">
            <div className="d-flex align-items-center">
              <div
                className="ai-coach-image"
                style={{
                  width: "50px",
                  height: "50px",
                  background:
                    "url('../../robot_icon.png') no-repeat center center",
                  backgroundSize: "contain",
                  marginRight: "10px",
                }}
              ></div>
              <h2 className="accordion-header" id="headingFive">
                <button
                  className="btn btn-outline w-100"
                  type="button"
                  style={{ color: "#800080", fontWeight: "bold" }}
                >
                  AI Coach
                </button>
              </h2>
            </div>
          </div>
        </div>
        {/* Add the confirmation modal */}
        <ConfirmationModal
          show={this.state.showConfirmationModal}
          handleConfirm={this.handleConfirmChange}
          onClose={this.handleCloseModal}
          selectedIndustry={this.state.newSelectedIndustry} // Pass the selected industry to the modal
        />
      </div>
    );
  }
}

export default Dropdown;
